import React from "react";
import { Container } from "react-bootstrap";
import analyze from "../../../Asset/ai/first.svg";
import sprint from "../../../Asset/ai/second.svg";
import build from "../../../Asset/ai/third.svg";
import review from "../../../Asset/ai/fourth.svg";
import test from "../../../Asset/ai/fifth.svg";

const Fifth = () => {
  return (
    <>
      <section
        className="seventh-mobileApp-section third-ai-section"
        style={{ backgroundColor: "var(--light-gray-color)" }}
      >
        <Container>
          <div className="row scroll-row">
            <div className="col-xl-5">
              <div className="mob-app-sec-7-wrapper">
                <h3>
                  Partner with Codeffi for{" "}
                  <strong>Custom AI Solutions For Your Business.</strong>
                </h3>
                <p>
                  Every business is unique and requires a personalized approach
                  to AI integration. Our custom AI solutions are designed to
                  perfectly align with your specific business needs, providing
                  numerous benefits
                </p>
              </div>
            </div>
            <div className="col-xl-7">
              <div className="sec-7-scroll-wrapper ">
                <div className="app-innovation-scroll d-flex">
                  <div className="card-img">
                    <img alt="card" src={analyze} className="w-100" />
                  </div>
                  <div className="card-content">
                    <h5>Greater Adaptability to Your Infrastructure</h5>
                    <div className="sort-info">
                      Our solutions seamlessly integrate with your existing
                      systems, ensuring smooth operations and high productivity.
                    </div>
                  </div>
                </div>
                <div className="app-innovation-scroll d-flex">
                  <div className="card-img">
                    <img alt="card" src={sprint} className="w-100" />
                  </div>
                  <div className="card-content">
                    <h5>Total Control of the Custom Model</h5>
                    <div className="sort-info">
                      Gain complete control over your AI models, tailored to fit
                      your business requirements, and ensuring long-term
                      relevance and effectiveness.
                    </div>
                  </div>
                </div>
                <div className="app-innovation-scroll d-flex">
                  <div className="card-img">
                    <img alt="card" src={build} className="w-100" />
                  </div>
                  <div className="card-content">
                    <h5>Significant Competitive Edge</h5>
                    <div className="sort-info">
                      Stay ahead of the competition with streamlined operations,
                      enhanced decision-making, and innovative product offerings
                      through our bespoke AI solutions.
                    </div>
                  </div>
                </div>
                <div className="app-innovation-scroll d-flex">
                  <div className="card-img">
                    <img alt="card" src={review} className="w-100" />
                  </div>
                  <div className="card-content">
                    <h5>Data Security & Confidentiality</h5>
                    <div className="sort-info">
                      We prioritize the security and confidentiality of your
                      data, building trust with your customers and protecting
                      your business interests.
                    </div>
                  </div>
                </div>
                <div className="app-innovation-scroll d-flex">
                  <div className="card-img">
                    <img alt="card" src={test} className="w-100" />
                  </div>
                  <div className="card-content">
                    <h5>Cost-Effective Solutions</h5>
                    <div className="sort-info">
                      Our custom AI solutions are designed to provide
                      significant value without unnecessary expenses, ensuring
                      cost-effectiveness for your business.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Container>
      </section>
    </>
  );
};

export default Fifth;
